export const ROLES = [
  { value: "super_admin", label: "Super Admin" },
  { value: "founder", label: "Founder / Director" },
  { value: "ops_manager", label: "Operations Manager" },
  { value: "hr_admin", label: "HR Admin" },
  { value: "business_consultant", label: "Business Consultant" },
  { value: "academy_counsellor", label: "Academy Counsellor" },
  { value: "study_abroad_counsellor", label: "Study Abroad Counsellor" },
  { value: "wealth_executive", label: "Wealth Executive" },
  { value: "digital_pm", label: "Digital Project Manager" },
  { value: "franchise_manager", label: "Franchise Manager" },
  { value: "employee", label: "Employee" },
  { value: "franchise_partner", label: "Franchise Partner" },
  { value: "student_client", label: "Student / Client" },
  { value: "external_partner", label: "External Partner" },
];

export const DIVISIONS = [
  { value: "academy", label: "Academy" },
  { value: "study_abroad", label: "Study Abroad" },
  { value: "mbbs_abroad", label: "MBBS Abroad" },
  { value: "indian_admissions", label: "Indian Admissions" },
  { value: "wealth", label: "Wealth" },
  { value: "digital", label: "Digital" },
];

export const ADMISSION_MODES = [
  { value: "online", label: "Online" },
  { value: "offline", label: "Offline" },
  { value: "hybrid", label: "Hybrid" },
];

export const LEAD_STATUSES = [
  { value: "new", label: "New" },
  { value: "contacted", label: "Contacted" },
  { value: "qualified", label: "Qualified" },
  { value: "proposal", label: "Proposal" },
  { value: "won", label: "Won" },
  { value: "lost", label: "Lost" },
];

export const OPP_STAGES = [
  { value: "discovery", label: "Discovery" },
  { value: "proposal", label: "Proposal" },
  { value: "negotiation", label: "Negotiation" },
  { value: "won", label: "Won" },
  { value: "lost", label: "Lost" },
];

export const TASK_STATUSES = [
  { value: "open", label: "Open" },
  { value: "in_progress", label: "In Progress" },
  { value: "done", label: "Done" },
];

export const roleLabel = (v) => ROLES.find((r) => r.value === v)?.label || v;
export const divisionLabel = (v) => DIVISIONS.find((d) => d.value === v)?.label || v;
export const statusLabel = (v) => LEAD_STATUSES.find((s) => s.value === v)?.label || v;
